import { useState } from 'react';
import { DynamicSEO } from '../components/seo';
import Layout from '../components/Layout';
import { Search } from 'lucide-react';
import GenderFilter from '../components/GenderFilter';
import AlphabetFilter from '../components/AlphabetFilter';
import NamesList from '../components/NamesList';

export default function BabyNamesPage() {
  const [selectedGender, setSelectedGender] = useState<'boys' | 'girls' | null>(null);
  const [selectedLetter, setSelectedLetter] = useState<string | null>(null);
  const [searchTerm, setSearchTerm] = useState('');

  return (
    <Layout>
      <DynamicSEO
        meta={{
          title: "Nepali Baby Names - Find Perfect Names with Meanings",
          description: "Browse our collection of beautiful Nepali baby names. Find meanings, origins, and cultural significance of names.",
          keywords: "nepali baby names, baby boy names, baby girl names, name meanings",
          type: "website"
        }}
      />
      
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Nepali Baby Names
          </h1>
          <p className="text-gray-600">
            Discover beautiful names for your little one with deep cultural meaning
          </p>
        </div>

        <div className="mb-8">
          <div className="relative max-w-2xl mx-auto">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search names..."
              className="w-full px-4 py-3 pl-12 rounded-lg border border-gray-200 focus:outline-none focus:ring-2 focus:ring-purple-500"
            />
            <Search 
              className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400"
              size={20}
            />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div className="lg:col-span-3">
            <div className="sticky top-4">
              <GenderFilter
                selectedGender={selectedGender}
                onGenderSelect={setSelectedGender}
              />
              <AlphabetFilter
                selectedLetter={selectedLetter}
                onLetterSelect={setSelectedLetter}
                gender={selectedGender}
              />
            </div>
          </div>

          <div className="lg:col-span-9">
            <NamesList
              gender={selectedGender}
              letter={selectedLetter}
              searchTerm={searchTerm}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}